import { SUBSCRIPTION_GET, SUBSCRIPTION_DELETE } from '../actions/subscriptions'
import apiCall from './call'

const model = 'subscriptions'

const state = {
  //
}

const getters = {
  //
}

const actions = {
  [SUBSCRIPTION_GET]: ({ commit, dispatch }, subscriptionID) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: model + '/' + subscriptionID })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [SUBSCRIPTION_DELETE]: ({ commit, dispatch }, subscriptionID) => {
    let subscriptions = { ids: [subscriptionID] }
    return new Promise((resolve, reject) => {
      apiCall({ url: model, data: subscriptions, method: 'DELETE' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

const mutations = {
  //
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/subscriptions.js